export class SavedBillingAddress{
  id:number;
  recipient:string;
  firma:string;
  street:string;
  zip:string;
  town:string;
  country: string;
}
